import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRollbar } from "@rollbar/react";
import { createContext, useContext, useEffect } from "react";
import { useAnalytics } from "use-analytics";
import Interstitial from "~/client/components/Interstitial";
import useGetMe from "~/client/hooks/api/useGetMe";
import { Content, LoadingIndicator } from "./styled";
const UserContext = createContext(undefined);
export const UserProvider = ({ children }) => {
    const analytics = useAnalytics();
    const rollbar = useRollbar();
    const { data, isError, isPending } = useGetMe();
    useEffect(() => {
        if (data === null || data === void 0 ? void 0 : data.userId) {
            analytics.identify(data.userId);
            rollbar.configure({
                payload: {
                    person: {
                        id: data.userId,
                    },
                },
            });
        }
    }, [analytics, data === null || data === void 0 ? void 0 : data.userId, rollbar]);
    if (isPending) {
        return (_jsx(Interstitial, { children: _jsxs(Content, { children: [_jsx(LoadingIndicator, {}), "Loading your user data\u2026"] }) }));
    }
    if (isError) {
        return (_jsx(Interstitial, { children: _jsx(Content, { children: "There was an error loading your data." }) }));
    }
    return (_jsx(UserContext.Provider, { value: { userId: data.userId }, children: children }));
};
export const useUserContext = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUserContext must be used within a UserProvider.");
    }
    return context;
};
